const $toggleSlide = function($container) {
  const container = $container || $('body');
  const $targets = container.find('@toggleSlide');
  const duration = 'fast';
  const $focus = $('input@focus');
  const $class = 'closed';

  $.each($targets, function() {
    const $this = $(this);
    const $trigger = $this.find('@toggleSlideTrigger');
    const $target = $this.find($('@toggleSlideContainer'));

    if (!$target.data('reverse')) {
      $target.hide();
      $trigger.addClass($class);
    }

    $trigger.on('click', (e) => {
      $trigger.toggleClass($class);

      const setFocus = () => {
        const $this = $(this);
        const $target = $this.find($('input@focus'));

        setTimeout(() => {
          $target.focus();
          $(window).trigger('resize');
        }, 100);
      };
      $target.slideToggle(duration, setFocus());
    });
  });
};

export default $toggleSlide;
